import { Button } from "@replicate/ui";
import type { ReactNode } from "react";
import { P, match } from "ts-pattern";
import type { Prediction } from "../../types";
import { isImageUrl, isVideoUrl } from "./util";

export function PassthruPrediction({
  cta,
  inputParamName,
  additionalQueryParams,
  model,
  prediction,
  startIcon,
  type,
}: {
  cta: string;
  inputParamName: string;
  model: `${string}/${string}`;
  prediction: Prediction;
  type: "image" | "video";
  startIcon: ReactNode;
  additionalQueryParams?: Record<string, string | number>;
}) {
  // First check if the prediction output is a URL or array with a single URL
  const predictionUrl = match(prediction.output)
    .with(P.string, (url) => url)
    .with(P.array(P.string), (urls) => (urls.length === 1 ? urls[0] : null))
    .otherwise(() => null);

  if (!predictionUrl) {
    return null;
  }

  // Validate that the URL is of the correct type
  const isValidType = match(type)
    .with("video", () => isVideoUrl(predictionUrl))
    .with("image", () => isImageUrl(predictionUrl))
    .otherwise(() => false);

  if (!isValidType) {
    return null;
  }

  const params = new URLSearchParams();
  params.set(inputParamName, predictionUrl);

  if (additionalQueryParams) {
    for (const [key, value] of Object.entries(additionalQueryParams)) {
      params.set(key, String(value));
    }
  }

  return (
    <Button
      startIcon={startIcon}
      variant="outlined"
      render={
        // biome-ignore lint/a11y/useAnchorContent: Content is injected by the component.
        <a href={`/${model}/?${params.toString()}`} />
      }
    >
      {cta}
    </Button>
  );
}
